export const wPlsContract = {
  abi: [
    {
      constant: true,
      inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
      payable: false,
      stateMutability: 'view',
      type: 'function',
    },
  ],
  address:
    process.env.NEXT_PUBLIC_ENV == 'development'
      ? '0x8a810ea8B121d08342E9e7696f4a9915cBE494B7'
      : '0xA1077a294dDE1B09bB078844df40758a5D0f9a27',
}
